import { Link } from 'react-router-dom';
import { Paywall } from '/src/components/Paywall';

import UfoPNG from '@crazyegginc/hatch/dist/images/illustration-ufo-gathering.png';
import UfoWebP from '@crazyegginc/hatch/dist/images/illustration-ufo-gathering.webp';

export function NotInstalledWall({ mini }) {
  return (
    <Paywall>
      <Paywall.Image
        webp={UfoWebP}
        fallback={UfoPNG}
        width={mini ? '80px' : '185px'}
        className={mini ? '!mb-3 !mt-2' : ''}
      />
      <Paywall.Title mini={mini}>To get started, install the tracking script</Paywall.Title>
      <Paywall.Body>
        To start tracking traffic and visitor behavior,
        <br />
        you&apos;ll need to install the tracking script.
      </Paywall.Body>
      <Paywall.Button component={Link} to="/install" className={mini ? '!mb-0' : ''}>
        Install tracking script
      </Paywall.Button>
    </Paywall>
  );
}

NotInstalledWall.displayName = 'NotInstalledWall';
